exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".elements-in-group-table {\n  border: solid 1px #dfe3e9;\n  height: 183px;\n  overflow: auto;\n  padding: 15px 9px;\n  color: #5b6779; }\n  .elements-in-group-table .element {\n    font-size: 12px;\n    margin-bottom: 6px; }\n  .elements-in-group-table .name {\n    display: inline-block;\n    white-space: nowrap;\n    max-width: 250px;\n    text-overflow: ellipsis;\n    overflow: hidden; }\n  .elements-in-group-table .oi-trash {\n    margin-top: 3px; }\n  .elements-in-group-table .no-results {\n    font-size: 12px;\n    font-style: italic;\n    color: #e22d43; }\n\n.group-filter {\n  margin-bottom: 0; }\n  .group-filter input {\n    border-radius: 4px 4px 0 0;\n    border-bottom: none;\n    border-color: #dfe3e9;\n    background-color: white; }\n  .group-filter .oi-magnifying-glass {\n    color: #babbc7; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/simple-delete-list/simple-delete-list.component.scss
// module id = ../../../../../src/app/shared/components/simple-delete-list/simple-delete-list.component.scss
// module chunks = 12